import React, { useState } from 'react';
import { Container, Row, Col, Card, Accordion, Nav } from 'react-bootstrap';

/**
 * FAQ Page
 * Frequently Asked Questions
 */
function FAQ() {
  const [activeCategory, setActiveCategory] = useState('what-can-i-send');

  const categories = [
    { id: 'what-can-i-send', label: 'What Can I Send' },
    { id: 'placing-order', label: 'Placing An Order' },
    { id: 'payments', label: 'Payments' },
    { id: 'preparing-items', label: 'Preparing Your Items' },
    { id: 'collections', label: 'Collections' },
    { id: 'tracking', label: 'Tracking' },
    { id: 'customs', label: 'Customs' },
    { id: 'delivery', label: 'Delivery' },
    { id: 'account', label: 'Account Access' },
    { id: 'other', label: 'Other' }
  ];

  return (
    <div className="bg-light min-vh-100">
      <Container className="py-5">
        <Row>
          {/* Left Sidebar - Help Topics */}
          <Col md={3}>
            <Card className="shadow-sm border-0 mb-4">
              <Card.Body>
                <h5 className="mb-3">Help Topics</h5>
                <Nav className="flex-column">
                  {categories.map((cat) => (
                    <Nav.Link
                      key={cat.id}
                      active={activeCategory === cat.id}
                      onClick={() => setActiveCategory(cat.id)}
                      className={`text-dark ${activeCategory === cat.id ? 'border-start border-success border-3 bg-light' : ''}`}
                      style={{ cursor: 'pointer', paddingLeft: activeCategory === cat.id ? '15px' : '10px' }}
                    >
                      {cat.label}
                    </Nav.Link>
                  ))}
                </Nav>
              </Card.Body>
            </Card>
          </Col>

          {/* Right Content - FAQ Content */}
          <Col md={9}>
            <Card className="shadow-sm border-0">
              <Card.Body className="p-5">
                {activeCategory === 'what-can-i-send' && (
                  <>
                    <h6 className="text-muted mb-2">WHAT CAN I SEND</h6>
                    <h2 className="mb-4">Is there anything I can't send?</h2>

                    <p className="mb-4">
                      Items which are prohibited on all BagAboard services include, but are not limited to, aerosols for any 
                      pressurized containers (perfume, nail varnish for any other flammable liquids, toner/ printer cartridges 
                      (unless new and in original packaging) medicinal and non-permissible food stuffs.
                    </p>

                    <p className="mb-4">
                      Please see the full list of prohibited items within our{' '}
                      <a href="/terms-and-conditions" target="_blank" rel="noopener noreferrer">terms and conditions</a>.
                    </p>

                    <p className="mb-4">
                      We also recommend that you check the customs regulations for your destination. Prohibited items for 
                      customs and security reasons, it is the sender's responsibility to ensure they comply with international 
                      customs, further information can be found on our destination pages{' '}
                      <a href="/destinations">here</a>.
                    </p>

                    <h4 className="mt-5 mb-3">AEROSOLS ARE STRICTLY PROHIBITED</h4>
                    <p className="mb-4">
                      Under both baggage aircraft security regulations strictly prohibit the sending of aerosols for any other 
                      pressurised container such as antiperspirant, deodorant, hairspray, spray paint, etc. These items cannot be 
                      sent under any circumstances on any BagAboard services.
                    </p>

                    <h4 className="mt-5 mb-3">Flammable Liquids ARE STRICTLY PROHIBITED</h4>
                    <p className="mb-4">
                      Under both baggage aircraft security regulations strictly prohibit the sending of flammable liquids of 
                      any kind including perfume, nail varnish, aftershave, cologne, lighter fuel, white spirit, petrol, kerosene 
                      and other solvents labeled as flammable, but also includes less obvious flammable liquids such as 
                      aftershave, nail varnish and perfume. These items cannot be sent under any circumstances on any BagAboard 
                      services.
                    </p>

                    <h4 className="mt-5 mb-3">TOILETRIES AND OTHER LIQUIDS, PASTES and GELS</h4>
                    <p className="mb-4">
                      Toiletries and other liquids, pastes and gels such as shower gel, toothpaste and hair straighteners are 
                      not an international express courier (including every route to and from the USA) as these are serviced by air.
                    </p>
                    <p className="mb-4">
                      Most liquids, pastes and gels (excluding flammable ones) e.g. nail varnish, and small size lip balms per 10ml 
                      flammable makeup and toothpaste can be sent on our European standard (not express), UK domestic & USA 
                      domestic services as these routes are serviced by road. Please ensure all items you will travel with them is 
                      securely sealed and wrapped.
                    </p>
                    <p className="mb-4">
                      If you are sending liquids, pastes or gels, regulatory requirements are now in place requiring shipping them 
                      within the same package (including within the same piece of luggage) as items or as individual items. We 
                      recommend that you wrap them securely in plastic bags and seal them well. Any bag found to contain 
                      electrical items and liquids, pastes or gels will be returned or held for collection.
                    </p>
                    <p className="mb-4">
                      If shipping between the EU and UK, body creams, moisturisers, sun cream and others cannot currently be 
                      sent, more information is available{' '}
                      <a href="#" onClick={(e) => e.preventDefault()}>here</a>.
                    </p>

                    <h4 className="mt-5 mb-3">ANIMAL AND PLANT BASED PRODUCTS INCLUDING FOOD</h4>
                    <p className="mb-4">
                      Fruit & vegetables, dairy products (including dried products containing dairy such as protein powder), meat, 
                      fish, nuts, seeds and perishable products of any kind are prohibited on all routes.
                    </p>
                    <p className="mb-4">
                      Honey and certain other items may be commercially air permitted on certain routes, please{' '}
                      <a href="/contact">click here</a> for further information.
                    </p>

                    <h4 className="mt-5 mb-3">Important: Battery Policy</h4>
                    <p className="mb-4">
                      This policy forms part of our terms of service.
                    </p>

                    <h5 className="mt-4 mb-3">Loose Batteries & Power Banks</h5>
                    <p className="mb-4">
                      We cannot accept shipments containing loose batteries or packets of batteries. Batteries can only be sent 
                      when included within a working device in line with the below guidance.
                    </p>
                    <p className="mb-4">
                      Power banks are also strictly prohibited on all services.
                    </p>

                    <h5 className="mt-4 mb-3">Lithium Batteries</h5>
                    <p className="mb-4">
                      Lithium batteries are a type of rechargeable battery found within mobile phones, tablets, laptops, cameras, 
                      e-cigarettes, vapes, power tools, electric scooters, wireless keyboards and many other devices.
                    </p>
                    <p className="mb-4">
                      Lithium batteries pose a serious fire risk and security regulations in place worldwide regarding the 
                      shipping of devices containing lithium batteries.
                    </p>
                    <p className="mb-4">
                      You are only permitted to ship ONE device containing a lithium battery, unless shipping to or from Australia 
                      or China, when you must not include any device containing batteries of any type.
                    </p>
                    <p className="mb-4">
                      If you are shipping more than one device, the lithium battery in the device must be switched off and 
                      must be packed in such a way that it will not turn on accidentally during transit. The device must also be 
                      packed away from any other items which could cause it to short circuit.
                    </p>
                    <p className="mb-4">
                      If you are sending a larger device you must ensure the battery power is less than 100Wh (Watt Hours) and 
                      the weight of the electrical device with the battery installed must not exceed 5kg.
                    </p>
                    <p className="mb-4">
                      If the battery is damaged, defective or recalled, it is strictly prohibited to send it. Batteries are 
                      suspected, to be damaged or defective. Any products containing lithium batteries which have been recalled 
                      from a retailer or manufacturer for any reason must also not be sent.
                    </p>
                    <p className="mb-4">
                      It is your responsibility to ensure that you comply with the above regulations. If you are unsure of the 
                      person or company identified on the shipper on the supplied shipping documents is legally responsible for 
                      complying with the above information. Failure to do so will result in the bag being confiscated and not 
                      either returned to you or in some cases seized by the local government's regulatory authority.
                    </p>

                    <h5 className="mt-4 mb-3">Alkaline Batteries</h5>
                    <p className="mb-4">
                      Alkaline batteries for example AA and AAA batteries sold by brands such as Duracell and Energizer are 
                      permitted to be sent (except to / from Australia & China*) as long as they are within a working device. Never 
                      send loose alkaline batteries or packets of alkaline batteries.
                    </p>
                    <p className="mb-4">
                      For example if you have three children's toys each with 2 x AA batteries inside, this is permitted (except to / 
                      from Australia & China*).
                    </p>
                    <p className="mb-4">
                      Items containing Alkaline batteries must be in working order and should be packed in such a way that they 
                      cannot switch on by accident.
                    </p>
                    <p className="mb-4">
                      *If you are shipping to / from Australia, alkaline batteries must not be shipped to or from Australia or China, you 
                      can still send the item which takes batteries but the batteries must not be included.
                    </p>
                    <p className="mb-4">
                      Popular related question: <a href="#" onClick={(e) => e.preventDefault()}>What can I send?</a>
                    </p>

                    <h4 className="mt-5 mb-3">SECURITY</h4>
                    <p className="mb-4">
                      ALL shipments are x-rayed and are subject to security searches. If you include prohibited items your 
                      shipment will not be loaded to an aircraft and will be returned to you or in some countries may be seized. No 
                      refund will be provided for shipments returned under these circumstances and a £25 security processing fee 
                      will be due before your shipment can be recollected. If your shipment is seized you will need to open a 
                      claim for compensation from your travel insurer or home contents insurer. You will be notified by email and 
                      tracked when our battery policy is violated.
                    </p>
                  </>
                )}

                {activeCategory === 'placing-order' && (
                  <>
                    <h6 className="text-muted mb-2">PLACING AN ORDER</h6>
                    <h2 className="mb-4">Placing An Order</h2>
                    <p>Information about placing orders will be displayed here.</p>
                  </>
                )}

                {activeCategory === 'payments' && (
                  <>
                    <h6 className="text-muted mb-2">PAYMENTS</h6>
                    <h2 className="mb-4">Payments</h2>
                    <p>Payment information will be displayed here.</p>
                  </>
                )}

                {/* Add more categories as needed */}
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FAQ;
